export const packetStepCopy = {
    /** The frame's "PDFs to review and sign". */
    'pdf-form': { one: 'PDF to review and sign', many: 'PDFs to review and sign' },
    /** The frame's "uploads". */
    'document-upload': { one: 'upload', many: 'uploads' },
    /** The frame's "to read and sign". */
    acknowledgment: { one: 'to read and sign', many: 'to read and sign' },
    /** The frame's "to fill in". */
    'candidate-application': { one: 'form to fill in', many: 'forms to fill in' },
    'date-credential': { one: 'licence or certification', many: 'licences or certifications' },
    'external-process': { one: 'handled in another system', many: 'handled in another system' },
    'hr-record': { one: 'recorded by our office', many: 'recorded by our office' },
    'info-task': { one: 'to read', many: 'to read' },
    'health-choice': { one: 'health choice', many: 'health choices' },
};
/** "7 uploads", "1 upload" — the chip's whole text. */
export function packetGroupLabel(type, count) {
    const copy = packetStepCopy[type];
    // An unknown type is still counted rather than dropped: the total must keep adding up, and a
    // packet the preview under-reports is the failure this screen exists to prevent.
    if (copy === undefined)
        return `${count} ${type}`;
    return `${count} ${count === 1 ? copy.one : copy.many}`;
}
//# sourceMappingURL=packet-copy.js.map